import { DATE_USER_HEADER_FILTER_COL_MIN_WIDTH } from './dateUserHeaderFilter';

/**
 * Jednotný výpočet minWidth hlavičky Tabulatora podľa mntn001 (`MaintenanceTypeList`).
 * Kotva: „Názov“ (5 znakov) = 70 + 5·8 = 110 px.
 * Multiselect (`primeMultiSelectHeaderFilter`): +10 px k základu (šírka ovládania).
 */
export const TABULATOR_COL_TITLE_BASE_PX = 70;
export const TABULATOR_COL_TITLE_PX_PER_CHAR = 8;
export const TABULATOR_COL_MULTISELECT_EXTRA_PX = 10;

/** Úzky stĺpec ID v lokálnych zoznamoch (gset001, šablóny, …). */
export const TABULATOR_LIST_ID_MIN_WIDTH = 76;

/**
 * @param {string} title - presný `title` stĺpca v Tabulatori
 * @param {'textInput' | 'multiselect'} [kind]
 */
export function tabulatorColumnMinWidthFromTitle(title, kind = 'textInput') {
  const t = title ?? '';
  const n = t.length;
  const kindExtra = kind === 'multiselect' ? TABULATOR_COL_MULTISELECT_EXTRA_PX : 0;
  const base = TABULATOR_COL_TITLE_BASE_PX + kindExtra;
  const raw = base + n * TABULATOR_COL_TITLE_PX_PER_CHAR;
  return Math.max(88, Math.ceil(raw));
}

/** Stĺpec s `dateUserHeaderFilter`: max(modulová konštanta, vzorec z titulku). */
export function tabulatorDateUserColumnMinWidth(title) {
  return Math.max(
    DATE_USER_HEADER_FILTER_COL_MIN_WIDTH,
    tabulatorColumnMinWidthFromTitle(title)
  );
}

/** Počet znakov rezervovaných na šírku textového filtra pre dátum typu dd.MM.yyyy (globálny vzorec). */
const TABULATOR_DATE_PLAIN_HEADER_FILTER_CHARS = 10;

/**
 * Stĺpec s dátumom v bunke a `inputOnEnterHeaderFilter` (bez kalendára v hlavičke).
 * minWidth = max(vzorec z titulku, podlaha z TABULATOR_COL_TITLE_* pre zobrazenie dátumu v hlavičke).
 */
export function tabulatorDatePlainInputColumnMinWidth(title) {
  const fromTitle = tabulatorColumnMinWidthFromTitle(title);
  const dateInputFloor = Math.max(
    88,
    Math.ceil(TABULATOR_COL_TITLE_BASE_PX + TABULATOR_DATE_PLAIN_HEADER_FILTER_CHARS * TABULATOR_COL_TITLE_PX_PER_CHAR)
  );
  return Math.max(fromTitle, dateInputFloor);
}
